import { render, staticRenderFns } from "./RemindListTrend.vue?vue&type=template&id=09416950&scoped=true"
import script from "./RemindListTrend.vue?vue&type=script&lang=js"
export * from "./RemindListTrend.vue?vue&type=script&lang=js"
import style0 from "./RemindListTrend.vue?vue&type=style&index=0&id=09416950&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09416950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09416950')) {
      api.createRecord('09416950', component.options)
    } else {
      api.reload('09416950', component.options)
    }
    module.hot.accept("./RemindListTrend.vue?vue&type=template&id=09416950&scoped=true", function () {
      api.rerender('09416950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/PsychologicalMonthReport/components/RemindListTrend.vue"
export default component.exports